import { config } from "@onflow/fcl";

config()
  .put('discovery.wallet', process.env.NEXT_PUBLIC_DAPPER_WALLET_DISCOVERY)
  .put('discovery.wallet.method', process.env.NEXT_PUBLIC_DAPPER_WALLET_DISCOVERY_METHOD)
  .put('accessNode.api', process.env.NEXT_PUBLIC_FLOW_ACCESS_NODE)
  .put('app.detail.title', 'Dapper Redemption')

function withDebug(config) {
  return config({
    'debug.accounts': true,
    'debug.signatures': true,
    'debug.resolved': true,
  });
}

if (process.env.NEXT_PUBLIC_FCL_DEBUG) {
  withDebug(config)
}
